import { getSettingData, changeSetting } from "@/api/myPractice"
import { isObjEmpty, preparePayload } from "./helper";
const generalPerferences = {
    namespaced: true,
    state: {
        old_personal: {},
        old_practice: {},
        // Whether notifyCustomerWhenAutomaticRedraw has been merged in from the
        // notificationPerferences module. Only the General Preferences tab needs
        // that field (its RedrawQuestion), so the merge — and the extra API call
        // behind it — is opt-in per caller rather than part of every fetch.
        notificationsMerged: false,
        infoURL: '/setting/getOrderingTestsInfo',
        postpracticeURL: '/setting/setOrderingtestsInfoClinic',
        postpersonalURL: '/setting/setOrderingtestsInfoCustomer'
    },
    getters: {
        old_practice: state => state.old_practice,
        old_personal: state => state.old_personal,
        personalURL: state => state.postpersonalURL,
        practiceURL: state => state.postpracticeURL,
        autoRedraw: state => (tab) => {
            if (tab === "clinic")
                return state.old_practice.optInAutomaticRedraw;
            else return state.old_personal.optInAutomaticRedraw;
        }
    },
    mutations: {
        SET_PRACTICE_DATA(state, practice_obj) {
            state.old_practice = practice_obj
        },
        SET_PERSONAL_DATA(state, personal_obj) {
            state.old_personal = personal_obj
        },
        SET_REDRAW_NOTIFICATION(state, { practiceValue, personalValue }) {
            state.old_practice = { ...state.old_practice, notifyCustomerWhenAutomaticRedraw: practiceValue }
            state.old_personal = { ...state.old_personal, notifyCustomerWhenAutomaticRedraw: personalValue }
            state.notificationsMerged = true
        },
        SET_DEFAULT(state) {
            state.old_personal = {}
            state.old_practice = {}
            state.notificationsMerged = false
        }
    },
    actions: {
        // withNotifications: also fetch notificationPerferences and merge
        // notifyCustomerWhenAutomaticRedraw into this module's data. Only the
        // General Preferences tab needs it; every other caller (e.g. the
        // settings shell, which fetches this purely for joinBetaProgram) leaves
        // it off and pays for one API call instead of two. The merge is tracked
        // separately from the base fetch so a shell-warmed store still gets it
        // when the General Preferences tab asks.
        async getSettingData({ commit, state, rootGetters }, { withNotifications = false } = {}) {
            const isSales = rootGetters['myPractice/userInfo/isInternalUser']
            if (isObjEmpty(state.old_personal)) {
                const res = await getSettingData(state.infoURL);
                const practiceData = res.data.practice
                const personalData = res.data.personal
                practiceData.salesChangeAllow = isSales ? "0" : practiceData.allowSuppliedByOffice;
                personalData.salesChangeAllow = isSales ? "0" : personalData.allowSuppliedByOffice;
                commit("SET_PRACTICE_DATA", practiceData)
                commit("SET_PERSONAL_DATA", personalData)
            }
            if (withNotifications && !state.notificationsMerged) {
                await this.dispatch('myPractice/notificationPerferences/getSettingData');
                commit("SET_REDRAW_NOTIFICATION", {
                    practiceValue: rootGetters['myPractice/notificationPerferences/old_practice'].notifyCustomerWhenAutomaticRedraw,
                    personalValue: rootGetters['myPractice/notificationPerferences/old_personal'].notifyCustomerWhenAutomaticRedraw,
                })
            }
        },
        setPracticeData({ commit }, practiceData) {
            commit("SET_PRACTICE_DATA", practiceData)
        },
        setPersonalData({ commit }, personalData) {
            commit("SET_PERSONAL_DATA", personalData)
        },
        async saveNewPracticeSetting({ state, commit }, newObj) {
            const payload = preparePayload("generalPerferences", state.old_practice, newObj)
            await changeSetting(state.postpracticeURL, payload);
            commit("SET_PRACTICE_DATA", { ...state.old_practice, ...newObj })
        },
        async saveNewPersonalSetting({ state, commit }, newObj) {
            const payload = preparePayload("generalPerferences", state.old_personal, newObj)
            await changeSetting(state.postpersonalURL, payload);
            commit("SET_PERSONAL_DATA", { ...state.old_personal, ...newObj })
        }
    },
}


export default generalPerferences;